"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldIntegrationMetadataToJSON = exports.FieldIntegrationMetadataFromJSONTyped = exports.FieldIntegrationMetadataFromJSON = void 0;
var IntegrationMetadata_1 = require("./IntegrationMetadata");
function FieldIntegrationMetadataFromJSON(json) {
    return FieldIntegrationMetadataFromJSONTyped(json, false);
}
exports.FieldIntegrationMetadataFromJSON = FieldIntegrationMetadataFromJSON;
function FieldIntegrationMetadataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if ((0, IntegrationMetadata_1.instanceOfIntegrationMetadata)(json)) {
        return (0, IntegrationMetadata_1.IntegrationMetadataFromJSONTyped)(json, true);
    }
    return {};
}
exports.FieldIntegrationMetadataFromJSONTyped = FieldIntegrationMetadataFromJSONTyped;
function FieldIntegrationMetadataToJSON(value) {
    if (value == null) {
        return value;
    }
    if ((0, IntegrationMetadata_1.instanceOfIntegrationMetadata)(value)) {
        return (0, IntegrationMetadata_1.IntegrationMetadataToJSON)(value);
    }
    return {};
}
exports.FieldIntegrationMetadataToJSON = FieldIntegrationMetadataToJSON;
